import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import { permissionNameIdMap } from 'hooks/business/useNewPermisson';
import { StoreScopesModal, getStoreCount } from 'components/StoreScopes';
import useModal from 'hooks/useModal';
import { Content } from 'views/Aide/Scenario/TaskForm/StoreScopesField';
import { Button } from 'antd';
import { ReactNode } from 'react';
import { FV } from './share';
import PopoverPreview from 'components/StoreScopes/PopoverPreview';

function StoreList() {
  const { t } = useTranslate();

  const { visible, show, hide } = useModal();

  return (
    <FormField<FV['storeList']>
      required
      name="storeList"
      label={t('aide.应用店铺')}
      validate={(value) => {
        const storeCount = getStoreCount(value);

        return storeCount === 0 ? t('aide.请选择应用店铺') : undefined;
      }}
    >
      {({ field: { value, onChange } }) => {
        const modal = (
          <StoreScopesModal
            permId={permissionNameIdMap['访问待办管理中心']}
            visible={visible}
            supportWa={false}
            showFooterTips={false}
            onCancel={hide}
            value={value}
            onChange={onChange}
          />
        );

        const render = (contentText: ReactNode, editText: ReactNode) => {
          return (
            <Content>
              {contentText && <div>{contentText}</div>}
              <Button type="link" onClick={show}>
                {editText}
              </Button>
              {modal}
            </Content>
          );
        };

        const storeCount = getStoreCount(value);

        if (storeCount === 0) {
          return render(null, t('remind.选择店铺'));
        }

        return render(<PopoverPreview value={value} />, t('phrase.重新选择'));
      }}
    </FormField>
  );
}

export default StoreList;
